module.exports = __webpack_public_path__ + "static/media/barcelona@2x.47967772.jpg";